import { Button, Carousel, Typography } from "antd";
import React from "react";
import { useTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import homeCarouselImage1 from "../../Assets/carouselImage1.png";
import homeCarouselImage2 from "../../Assets/carouselImage2.png";
import homeCarouselImage3 from "../../Assets/carouselImage3.png";
import { Routes } from "../../Utils/Constants/routes";
import "./index.css";

const HomePage: React.FC<WithTranslation & RouteComponentProps> = ({
  history: { push },
}) => {
  const { Text, Paragraph } = Typography;

  const logIn = () => push(Routes.login);

  const signUp = () => push(Routes.signup);
  const { t } = useTranslation();

  return (
    <div className="homePageRoot">
      <Carousel autoplay={true} dots={{ className: "dots" }}>
        <div id="carouselLayout">
          <Paragraph className="typoGraphyPara">
            <Text className="carouselText" strong={true}>
              {t("Express, Informed Consent")}
            </Text>{" "}
            {t("to third party requesting your financial data")}
          </Paragraph>

          <img src={homeCarouselImage1} alt="" />
        </div>

        <div id="carouselLayout">
          <Paragraph className="typoGraphyPara">
            <Text className="carouselText" strong={true}>
              {t("Link Your Financial Accounts")}
            </Text>{" "}
            {t("with your AA pbfin profile")}
          </Paragraph>
          <img src={homeCarouselImage2} alt="" />
        </div>

        <div id="carouselLayout">
          <Paragraph className="typoGraphyPara">
            <Text className="carouselText" strong={true}>
              {t("Track your consents and data sharing activity")}
            </Text>{" "}
            {t("with your AA pbfin profile")}
          </Paragraph>
          <img src={homeCarouselImage3} alt="" />
        </div>
      </Carousel>

      <Button
        className="primaryButton"
        id="loginButtonHomePage"
        onClick={logIn}
      >
        {t("LOGIN")}
      </Button>

      <Text className="donthaveaccountText">{t("Don't have an account")}</Text>

      <Button
        className="primaryButton"
        id="createAccountButton"
        onClick={signUp}
        type="text"
      >
        {t("Create Account")}
      </Button>
    </div>
  );
};

export default HomePage;
